// extracted by mini-css-extract-plugin
export var drawerPaper = "_1m-0";
export var itemImage = "_1m-1";